const APPLICATION_CONSTANTS = {
    CREATE_PASSWORD_URL: '/create-password',
    LOGIN_URL: '/login',
    CREATE_NEW_USER_ENDPOINT: '/public/v1/user/eid/profile',
    REGISTRY_ENDPOINT: '/user/map/registry',
    USER_INFORMATION_URL: '/user-information',
    COMPANY_INFORMATION_URL: '/company-information',
    NEW_USER_URL: '/create-amexid',
    SUCCESS_NEW_USER_URL: '/created-amexid',
    USER_DETAILS: '/user/permissions',
    THANK_YOU_URL: '/thank-you',
    ERROR_URL: '/error',
    EMPTY_URL: '/',
    /* eslint-disable-next-line no-useless-escape -- TBD */
    NAME_REGEX: /^[\w !"#$%&'()*+,./:,<=>?@[\\\]^`{|}~\-]+$/,
    NAME_PATTERN_REGEX: /^[a-zA-Z '\\-]+$/,
    CPG_NAME_REGEX: /^[a-zA-Z0-9~!@#$%^&*()_|:?,.\\\][\- ]+$/,
    CPG_LEGAL_NAME_REGEX: /^[a-zA-Z0-9\-&@ ]+$/,
    CITY_REGEX: /^[a-zA-Z0-9~!@#$%^&*()_|:?`"',\\\][\- ]+$/,
    /* eslint-disable-next-line no-useless-escape -- TBD */
    EMAIL_REGEX: /^(([^\s"(),.:,<>@[\\\]]+(\.[^\s"(),.:,<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/,
    PASSWORD_REGEX: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$/,
    POSTAL_CODE_REGEX: /^(\d{5}(-\d{4})?|[A-Z]\d[A-Z] *\d[A-Z]\d)$/,
    BASENAME: '/buyer-onboarding',
    VERIFY_TOKEN_API_URL: '/verifytoken?token=',
    SET_PASSWORD_API_URL: '/setpassword',
    LOGIN_API_URL: '/login',
    LOGOUT_API_URL: '/logout',
    AOF_URL: '/cao?siteName=',
    CAO_URL: '/cao',
    STATE_API_URL: '/regioninfo/stateprovince?iso_code=USA',
    UPDATE_PASSWORD_CREATION_STATUS_API_URL: '/buyerenrolment/enrolmentstatus?status=5&siteName=',
    TOKEN_NAME: 'token',
    PCN_NUMBER: 'pcnNumber',
    PCN_NO:"pcnIntialLoad",
    FORGOT_PASSWORD_URL: '/forgotpassword',
    FORGOT_EMAIL_SUCCESS: '/forgotemailsuccess',
    USER_UPDATE_API_URL: '/users/',
    USER_UPDATE_API_URL_PASSTHROUGH: '/OneIdentityProfile',
    PCN_DECRYPT_URL: '/admin/getSite/pcn/decrypt/',
    KYC_URL: '/admin/getSite/pcn/',
    PO_BOX_REGEX: /[pP][^a-zA-Z\d]*[oO][^a-zA-Z\d]*[bB][oO][xX].*$/,
    VERIFY_USER_URL: '/verify-user',
    VERIFY_RSVP_CODE: '/admin/verifyUser/token',
    CONFIRM_MOBILE_URL: '/admin/verifyUser/confirmMobile',
    VERIFYUSERPHONENUMBER_URL : '/admin/verifyUser/phone',
    STATUS_URL: '/status',
    ADDRESS_VERIFY_URL: '/dbo/address-verify',
    AXP_HEADER_E1_URL: 'https://origin-navigation-latest-dev.americanexpress.com/partials/en-US/axp-global-header/v0',
    AXP_HEADER_E2_URL: 'https://navigation-qa.americanexpress.com/partials/en-US/axp-global-header/v0',
    AXP_HEADER_E3_URL: 'https://navigation.americanexpress.com/partials/en-US/axp-global-header/v0',
    AXP_FOOTER_E1_URL: 'https://origin-navigation-latest-dev.americanexpress.com/partials/en-US/axp-footer/v0',
    AXP_FOOTER_E2_URL: 'https://navigation-qa.americanexpress.com/partials/en-US/axp-footer/v0',
    AXP_FOOTER_E3_URL: 'https://navigation.americanexpress.com/partials/en-US/axp-footer/v0',
    ONE_IDENTITY_E1_URL: 'https://dwww.americanexpress.com/en-us/account/light/login',
    ONE_IDENTITY_E2_URL: 'https://qwww.americanexpress.com/en-us/account/light/login',
    ONE_IDENTITY_E3_URL: 'https://www.americanexpress.com/en-us/account/light/login',
    ONE_AP_E1_URL: 'https://oneap-dev.americanexpress.com/',
    ONE_AP_E2_URL: 'https://oneapstg.americanexpress.com/',
    ONE_AP_E3_URL: 'https://oneap.americanexpress.com/',
    USM_E1_URL: 'https://cdaas-dev.americanexpress.com/one/axp-script-supplier/6.0.9/script-supplier.js',
    USM_E2_URL: 'https://qwww.aexp-static.com/cdaas/one/axp-script-supplier/6.0.9/script-supplier.js',
    USM_E3_URL: 'https://www.aexp-static.com/cdaas/one/axp-script-supplier/6.0.9/script-supplier.js',
    ONE_IDENTITY_PASSWORD_E1_URL: 'https://dwww.americanexpress.com/en-us/account/password/recover',
    ONE_IDENTITY_PASSWORD_E2_URL: 'https://qwww.americanexpress.com/en-us/account/password/recover',
    ONE_IDENTITY_PASSWORD_E3_URL: 'https://www.americanexpress.com/en-us/account/password/recover',
    ONE_IDENTITY_MANAGE_E1_URL: 'https://dwww.americanexpress.com/en-us/account/profile/manage',
    ONE_IDENTITY_MANAGE_E2_URL: 'https://qwww.americanexpress.com/en-us/account/profile/manage',
    ONE_IDENTITY_MANAGE_E3_URL: 'https://www.americanexpress.com/en-us/account/profile/manage',
};
export default APPLICATION_CONSTANTS;
